import { translateBackend } from 'assets/i18n/config';
import { TextField } from '../..';

export const TextFieldEdit = ({
  option, options, setOptions, i,
}: {
  option: any, options: any, setOptions: (x: any) => void, i: number
}) => (
   <TextField
   sx={{ mb: 2 }}
   fullWidth
   label={translateBackend(option.label)}
   value={option?.value}
   onChange={(e: any) => {
     const newOptions = [...options];
     newOptions[i].value = e.target.value;
     setOptions(newOptions);
   }}
   />
);
